import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../utils/axios";
import {
    CALL_PPOR_API,
    MIDDLE_WARE_BASE_URL_v1,
} from "../../../../utils/CONSTANTS";

const initialState = {
    submitState: "",
    submitData: null as any,
    submitError: null as any,
};

export const submitOnboardingForms: any = createAsyncThunk(
    "post/submitOnboardingForms",
    async (data: any, { rejectWithValue }) => {
        try {
            const payload = {
                action: data.action,
                oracleId: data.oracleId,
                id: data.id,
                employeeUid: data.employeeUid,
                requestData: typeof data.requestData === "string"
                    ? data.requestData
                    : JSON.stringify(data.requestData),
            };
            const wireBody = JSON.stringify(JSON.stringify(payload));
            const response = await axios.postRequest(
                MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
                wireBody
            );

            return response;
        } catch (err: any) {
            const backendMsg =
                err?.response?.data?.error ??
                err?.response?.data?.response ??
                err?.response?.data?.title ??
                err?.response?.data ??
                err?.message ??
                "Submission failed";
            console.error("submitOnboardingForms error:", err?.response?.status, err?.response?.data);
            return rejectWithValue(backendMsg);
        }
    }
);

const onboardingFormsSlice = createSlice({
    name: "onboardingForms",
    initialState,
    reducers: {
        resetSubmitState: (state) => {
            state.submitState = "";
            state.submitData = null;
            state.submitError = null;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(submitOnboardingForms.pending, (state) => {
                state.submitState = "pending";
                state.submitData = null;
                state.submitError = null;
            })
            .addCase(submitOnboardingForms.fulfilled, (state, action) => {
                state.submitState = "fulfilled";
                state.submitData = action.payload;
                state.submitError = null;
            })
            .addCase(submitOnboardingForms.rejected, (state, action) => {
                state.submitState = "failed";
                state.submitData = null;
                state.submitError = action.payload ?? action.error?.message ?? "Submission failed";
            }),
});

export const { resetSubmitState } = onboardingFormsSlice.actions;
export const getOnboardingFormsDetails = (state: any) => state.onboardingForms;
export default onboardingFormsSlice.reducer;